import {
  isEnabledFreshEvent,
  isEnabledFreshNews,
  isEnabledFreshReview,
  isEnabledNewCard,
  isEnabledPremiumReviewCard,
  isEnabledRankingCard,
  isEnabledRelationProductCard,
  isEnabledShortcutCard,
  isEnabledSpecialEvent,
  SubVertical,
} from 'common/constants'
import { ListCommonParam } from 'common/types/params'

export enum ListItem {
  WINDOWPRODUCT = 'WINDOWPRODUCT',
  WINDOWPRODUCT_WITH_LATEST_NEWS = 'WINDOWPRODUCT_WITH_LATEST_NEWS',
  NEWS = 'NEWS',
  FRESH_NEWS = 'FRESH_NEWS',
  DIRECT_FARM_LOCAL_FOOD_HOME_NEWS = 'DIRECT_FARM_LOCAL_FOOD_HOME_NEWS',
  SHORTCUT = 'SHORTCUT',
  PREMIUM_REVIEW = 'PREMIUMREVIEW',
  FRESH_REVIEW = 'FRESH_REVIEW',
  RELATION_PRODUCT = 'RELATION_PRODUCT',
  STORE_RANK = 'STORE_RANK',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
  FRESH_EVENT = 'FRESH_EVENT',
  POPULARITY = 'POPULARITY',
  VMD_RELATION_WINDOW_PRODUCT = 'VMD_RELATION_WINDOW_PRODUCT',
  COORDI_PRODUCT = 'COORDI_PRODUCT',
  RECOMMEND_WINDOW_PRODUCT = 'RECOMMEND_WINDOW_PRODUCT',
  LINK = 'LINK',
  TRADITIONAL_ALCOHOL_HOME = 'TRADITIONAL_ALCOHOL_HOME',
  SPECIAL_EVENT_HAS_PRODUCT = 'SPECIAL_EVENT_HAS_PRODUCT',
  SPECIAL_EVENT_HAS_PRODUCT_HOME = 'SPECIAL_EVENT_HAS_PRODUCT_HOME',
  RECOMMEND_REVIEW = 'RECOMMEND_REVIEW',
  DIRECT_FARM_LOCAL_FOOD_NEWS = 'DIRECT_FARM_LOCAL_FOOD_NEWS',
}

export interface CardDescriptor {
  type: ListItem
  fetchParams?: ListCommonParam
  renderOptions?: any
  render?: Function
}

export const usedCardInSubVertical = (type: ListItem, subVertical: SubVertical) => {
  switch (type) {
    case ListItem.WINDOWPRODUCT:
      return true
    case ListItem.RELATION_PRODUCT:
    case ListItem.COORDI_PRODUCT:
      return isEnabledRelationProductCard(subVertical)
    case ListItem.NEWS:
      return isEnabledNewCard(subVertical)
    case ListItem.FRESH_NEWS:
      return isEnabledFreshNews(subVertical)
    case ListItem.PREMIUM_REVIEW:
      return isEnabledPremiumReviewCard(subVertical)
    case ListItem.FRESH_REVIEW:
      return isEnabledFreshReview(subVertical)
    case ListItem.SHORTCUT:
      return isEnabledShortcutCard(subVertical)
    case ListItem.STORE_RANK:
      return isEnabledRankingCard(subVertical)
    case ListItem.SPECIAL_EVENT:
      return isEnabledSpecialEvent(subVertical)
    case ListItem.FRESH_EVENT:
      return isEnabledFreshEvent(subVertical)
  }
}

export interface CardPosition {
  pos: number[]
  isAbsolutePos?: boolean
  sequentialCardCount?: number // 연속적으로 노출되는 카드 수
  dataCount: number // 카드 한 개를 구성하는 데이터 건수
  startPage?: number
  pageInterval: number // 페이지 간격
}

export type CardPositionConf = { [key in ListItem]?: CardPosition }

// pos start from 1
export const defaultCardPositionConf: CardPositionConf = {
  WINDOWPRODUCT: {
    pos: [1],
    dataCount: 1,
    pageInterval: 1,
  },
  RELATION_PRODUCT: {
    pos: [5, 10],
    dataCount: 1,
    pageInterval: 1,
  },
  COORDI_PRODUCT: {
    pos: [1],
    dataCount: 1,
    pageInterval: 1,
  },
  NEWS: {
    pos: [5],
    dataCount: 3,
    pageInterval: 1,
  },
  FRESH_NEWS: {
    pos: [8],
    dataCount: 3,
    startPage: 2,
    pageInterval: 3,
  },
  PREMIUMREVIEW: {
    pos: [2],
    dataCount: 1,
    pageInterval: 2,
  },
  FRESH_REVIEW: {
    pos: [7],
    dataCount: 1,
    startPage: 3,
    pageInterval: 3,
  },
  STORE_RANK: {
    pos: [7, 15],
    isAbsolutePos: true,
    dataCount: 7,
    pageInterval: 1,
  },
  SPECIAL_EVENT: {
    pos: [8],
    dataCount: 1,
    pageInterval: 1,
  },
  FRESH_EVENT: {
    pos: [9],
    dataCount: 1,
    startPage: 1,
    pageInterval: 3,
  },
}
